module.exports = __webpack_public_path__ + "img/facebook-icon.94380559.svg";